import styled from 'styled-components'
import { Card, CardBody, Text, WaitIcon } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { NodeRound, BetPosition } from 'state/types'
import useTheme from 'hooks/useTheme'
import { useGetCurrentRoundCloseTimestamp, useGetIntervalSeconds } from 'state/predictions/hooks'
import { formatRoundTime } from '../../helpers'
import useCountdown from '../../hooks/useCountdown'
import { RoundResultBox } from '../RoundResult'
import MultiplierArrow from './MultiplierArrow'
import CardHeader, { getBorderBackground } from './CardHeader'

interface SoonRoundCardProps {
  round: NodeRound
  currentEpoch: number
}

const CountdownWrapper = styled(Text)`
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

const SoonRoundCard: React.FC<React.PropsWithChildren<SoonRoundCardProps>> = ({ round, currentEpoch }) => {
  const intervalSeconds = useGetIntervalSeconds()
  const currentRoundCloseTimestamp = useGetCurrentRoundCloseTimestamp()
  const { secondsRemaining } = useCountdown(
    currentRoundCloseTimestamp + intervalSeconds * (round.epoch - currentEpoch - 1),
  )
  // const { secondsRemaining } = useCountdown(round.startTimestamp + intervalSeconds + ROUND_BUFFER)

  const countdown = formatRoundTime(secondsRemaining)
  const { t } = useTranslation()
  const { theme } = useTheme()

  return (
    <Card borderBackground={getBorderBackground(theme, 'soon')}>
      <CardHeader status="soon" icon={<WaitIcon mr="4px" width="24px" />} title={t('Later')} epoch={round.epoch} />
      <CardBody p="16px">
        <MultiplierArrow isDisabled />
        <RoundResultBox>
          <CountdownWrapper textAlign="center">
            <Text bold>{t('Entry starts')}</Text>
            <Text fontSize="24px" fontWeight={700}>
              {`~ ${countdown}`}
            </Text>
          </CountdownWrapper>
        </RoundResultBox>
        <MultiplierArrow betPosition={BetPosition.BEAR} isDisabled />
      </CardBody>
    </Card>
  )
}

export default SoonRoundCard
